export const BEYOND_WORDS_SCRIPT =
  "https://proxy.beyondwords.io/npm/@beyondwords/player@0.4.2/dist/umd.js";
export const BEYOND_WORDS_API_BASE_URL = "https://api.beyondwords.io/v1";
export const TOOLTIP_STORAGE_KEY = "hasSeenTTSTooltip";
export const CRAWL_START_DATE = "Jul 17, 2025";
